var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_92_1140)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M8.34087 0.232209C8.69087 -0.0770776 9.28149 -0.0770776 9.65962 0.232209L17.6596 6.79418C18.0752 7.13696 18.1159 7.72875 17.7534 8.1184C17.3877 8.50805 16.7565 8.54614 16.3409 8.20629L9.00024 2.18344L1.65868 8.20629C1.24305 8.54614 0.61149 8.50805 0.247678 8.1184C-0.11601 7.72875 -0.0738849 7.13696 0.341803 6.79418L8.34087 0.232209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.00011 2.18323L16.0032 7.92776L16.0157 13.8252C16.0189 14.4727 15.4595 15 14.7657 15H12.2501C11.5595 15 11.0001 14.4756 11.0001 13.8281V11.2412C11.0001 10.7227 10.5532 10.3037 10.0001 10.3037H8.00011C7.44698 10.3037 7.00011 10.7227 7.00011 11.2412V13.8281C7.00011 14.4756 6.44073 15 5.75011 15H3.25323C2.53448 15 2.00292 14.4756 2.00261 13.8281L2.00073 7.92483L9.00011 2.18323Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_92_1140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.1bcfe57ddc725bab86503bf793375753.svg";
export { ForwardRef as ReactComponent };